import ototransRepository from "domain/repository/main/ototransRepository";

export default class OtotransPartnerUseCase {
  constructor(private repository: ototransRepository) {}

  async getPartner() {
    return await this.repository.getOtotransPartnerList();
  }
}
